import { Trans, useTranslation } from 'react-i18next'
import { Alert, Collapse, Fade, AlertTitle, CircularProgress, useTheme } from '@mui/material'

import { FieldModel } from '@cibo/core'

import { useUnprofiledFieldsCount } from '../../pages/ProfileFields'

export const ProfileFieldsAlert = ({
  fieldId,
  hasMatches,
  onClick,
}: {
  fieldId?: string
  hasMatches?: boolean
  onClick: (resourceIds?: string[]) => void
}) => {
  const unprofiledFields = useUnprofiledFieldsCount(fieldId ? { resourceIds: fieldId } : {})
  const { t } = useTranslation('impact/components/ProfileFieldsAlert')
  const {
    palette: { mode },
  } = useTheme()
  return (
    <Collapse in={!!unprofiledFields.data?.numAvailable}>
      <Fade in={!!unprofiledFields.data?.numAvailable}>
        <Alert
          onClick={() =>
            onClick(unprofiledFields.data?.items.map(({ resourceId }: FieldModel) => resourceId))
          }
          sx={{ '&:hover': { cursor: 'pointer' } }}
          severity="warning"
          icon={unprofiledFields.isLoading ? <CircularProgress size={22} /> : undefined}
          variant={mode === 'dark' ? 'filled' : 'standard'}
        >
          <AlertTitle>{t('informationNeeded')}</AlertTitle>
          <Trans
            i18nKey={`impact/components/ProfileFieldsAlert:${
              fieldId ? (hasMatches ? 'profileFieldMore' : 'profileField') : 'profileFields'
            }`}
            count={unprofiledFields.data?.numAvailable}
            values={{
              name: unprofiledFields.data?.items?.[0]?.name,
              count: unprofiledFields.data?.numAvailable,
              number: unprofiledFields.data?.numAvailable,
            }}
          >
            missing <strong>click</strong> data
          </Trans>
        </Alert>
      </Fade>
    </Collapse>
  )
}
